// extracted by mini-css-extract-plugin
module.exports = {"OnlineStoreRightsA3":"OnlineStoreRightsA3_OnlineStoreRightsA3__73qw4"};